var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49758_51942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.774257 22.275L1.93301 19.1831L2.72988 17.055C2.90988 16.5056 2.94363 16.2787 3.24926 15.9731L5.46551 13.7568L10.2393 18.5306L8.02113 20.7487C7.83926 20.9306 7.49051 21.0862 6.94113 21.2662L4.81301 22.0631L1.72113 23.2218C1.13801 23.4112 0.584882 22.8581 0.774257 22.275Z",
    fill: "#FFECB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72122 23.2219L4.28247 22.2619C4.28247 22.2619 3.22497 22.2019 2.5106 21.4875C1.79622 20.7731 1.73435 19.7137 1.73435 19.7137L0.774346 22.275C0.58497 22.8581 1.1381 23.4112 1.72122 23.2219Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9037 3.32059L16.9181 6.93747L20.6756 8.09247L22.7981 5.97185C23.3831 5.38685 23.6606 4.2206 22.1099 2.66997L21.1743 1.73435C19.8337 0.39372 18.6093 0.613095 18.0243 1.1981L15.9037 3.32059Z",
    fill: "#EF5350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5742 8.37003L15.6298 6.42566L4.33672 17.7188C4.33672 17.7188 4.10609 18.6788 4.69297 19.2657C5.27984 19.8525 6.28109 19.6632 6.28109 19.6632L17.5742 8.37003Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.988 9.78375L8.00429 20.7675C6.23054 21.1537 6.30741 19.6369 6.30741 19.6369L17.5743 8.37L18.988 9.78375Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6279 6.42376L4.36106 17.6906C4.36106 17.6906 2.3323 17.6906 3.26043 15.9638L14.2142 5.01001L15.6279 6.42376Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32435 19.8825L17.6887 8.51816L17.4243 8.25378L5.98685 19.6913L6.28122 19.6613L6.32435 19.8825Z",
    fill: "#D1762C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29168 18.0281L16.4717 5.84812L16.2054 5.58374L4.1173 17.6719L4.33668 17.7169L4.29168 18.0281Z",
    fill: "#F19534"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.2143 5.01001C14.2143 5.01001 15.2399 6.52688 16.0893 7.38563C17.7149 9.02438 18.988 9.78376 18.988 9.78376L18.6599 10.1119C18.193 9.93001 16.9987 9.38439 15.8062 8.19376C14.6062 6.99376 14.0399 5.82188 13.8505 5.37376L14.2143 5.01001Z",
    fill: "#4E342E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5956 9.73126C19.4906 9.83626 19.3425 9.88313 19.1962 9.85876C19.1962 9.85876 17.6606 9.39001 16.1344 7.86376C14.6081 6.33751 14.1037 4.85063 14.1037 4.85063C14.0794 4.70438 14.1262 4.55438 14.2312 4.44938L15.84 2.84063C15.9075 2.77313 16.0012 2.73751 16.095 2.74876C16.1269 2.75251 16.1587 2.75626 16.1925 2.76188C16.32 2.78063 16.4212 2.87438 16.4569 2.99813C16.4569 2.99813 17.1919 4.42313 18.4031 5.63251C19.6144 6.84188 21.0919 7.54688 21.0919 7.54688C21.2156 7.58063 21.3112 7.68001 21.33 7.80751C21.33 7.80938 21.33 7.80938 21.33 7.81126C21.345 7.91251 21.3112 8.01376 21.24 8.08501L19.5956 9.73126Z",
    fill: "#94D1E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5886 3.41054C19.488 2.31001 18.86 1.1537 19.1859 0.827861C19.5117 0.50202 20.668 1.13003 21.7685 2.23057C22.8691 3.33111 23.4971 4.48741 23.1712 4.81325C22.8454 5.13909 21.6891 4.51108 20.5886 3.41054Z",
    fill: "#FF8383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.198 4.07617C16.8149 5.25742 17.8293 6.2268 19.0368 6.78742C19.1155 6.82305 19.2261 6.8493 19.273 6.77805C19.3086 6.7218 19.2768 6.65055 19.2411 6.5943C19.0836 6.35055 18.8661 6.15367 18.6561 5.95305C18.1086 5.42805 17.6061 4.85805 17.1543 4.25055C16.9236 3.94117 16.708 3.62242 16.5055 3.2943C16.393 3.1143 16.1924 2.73367 15.9355 3.0018C15.7124 3.23242 16.0799 3.8493 16.198 4.07617Z",
    fill: "#B9E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8975 6.27558C16.9463 6.32621 16.9969 6.37683 17.0213 6.44245C17.0457 6.50808 17.0363 6.59245 16.98 6.6337C16.9332 6.66933 16.8694 6.66558 16.8113 6.6562C16.4869 6.60558 16.2 6.42183 15.9469 6.21558C15.3938 5.76745 14.925 5.14495 14.88 4.43433C14.8744 4.34995 14.8763 4.26183 14.9138 4.18683C15.1519 3.7162 15.6563 4.76808 15.7557 4.9162C16.0875 5.40933 16.4832 5.85183 16.8975 6.27558Z",
    fill: "#B9E4EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49758_51942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e8084279418a3551bd3ebdb7ee2511f7.svg";
export { ForwardRef as ReactComponent };